import { render, staticRenderFns } from "./ProductivityStatsCard.vue?vue&type=template&id=e536a848&scoped=true&"
import script from "./ProductivityStatsCard.vue?vue&type=script&lang=js&"
export * from "./ProductivityStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityStatsCard.vue?vue&type=style&index=0&id=e536a848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e536a848",
  null
  
)

export default component.exports